import * as _ from 'lodash'
import * as React from 'react'
import Persistence from '../Components/Persistence'

import { Link, Navigate } from 'react-router-dom'
import SDKFactory from '../Components/SDKFactory'

import { T } from '@homeschooling/sdk'

import { InputField } from '../Components/Form/InputField'
//import { Loader } from '../Components/Common'

Persistence.setValues()

interface Form {
  [key: string]: string
}

interface Props { }

interface State {
    user: number,
    form: Form,
    errors: String[],
    requestSent: boolean,
    showLoader: boolean,
    goToAccount: boolean
}

export class Forgot extends React.Component<Props, State> {
    private sdk = SDKFactory.getUsersSDK()

    public constructor (props: Props) {
        super(props)
   
        const queryString = window.location.search
        const params = new URLSearchParams(queryString)

        let token = params.get('token')
        let loader = false

        if(token !== null) {
          this.loginWithToken(token)
          loader = true
        }

        this.state = {
          user: 0,
          form: {
            email: '',
          },
          errors: [],
          requestSent: false,
          showLoader: loader,
          goToAccount: false
        }

      }

      public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          const { form } = this.state
          form[key] = e.target.value

          this.setState({
            form,
          })
        }   

    public loginWithToken = async (token: string) => {

        try {

            this.setState({showLoader: true})
            
            const res = await this.sdk
              .verifyUserWithToken(
                token
              )
      
              let user = res.data
              const hasError: boolean = _.get(res, 'error', false) as boolean
              if(!hasError){
                user = user as T.User
                Persistence.setAuth(user)
                this.setState({user: Number(user.id), goToAccount: true})
              }
          } catch (reason) {
            this.setState({showLoader: false, errors: ['Token not valid try again']})
            console.log('That email combination was not found.  Please contact support or try again.')
          }  
    }    

    public verify = async () => {

        try {
            const res = await this.sdk
              .requestPasswordReset(
                this.state.form.email
              )
      
              const hasError: boolean = _.get(res, 'error', false) as boolean
              if(!hasError){
                this.setState({requestSent: true})
              }
          } catch (reason) {
            console.log('That email combination was not found.  Please contact support or try again.')
          }  
    }

      public render () {
        const { form} = this.state
        const user = Persistence.getUserId()

        if(this.state.goToAccount) {
          return(<Navigate to='/account' />)
        }

        if(user > 0) {
            return(<Navigate to='/dashboard' />)
        }

        if(this.state.showLoader){
          return (
          <section className="bg-gray-50 dark:bg-gray-900 border-y-2">
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
              <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 justify-items-center">
                  <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                    <div className="h-10 w-10 rounded-full border-4 border-purple-500 border-t-transparent animate-spin"></div>
                  </div>
              </div>
          </div>
        </section>)
        }

        return (
          <section className="bg-gray-50 dark:bg-gray-900 border-y-2">
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
              <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                  <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                          Enter the email you  used to sign up
                      </h1>
                      <form noValidate className="space-y-4 md:space-y-6">
                          <div>
                          <InputField
                            borderColor='default'
                            cb={this.inputChanged('email')}
                            disabled={false}
                            errors={this.state.errors.length > 0 ? true : false}
                            helperErrors={true}
                            label={'Email'}
                            labelColor='default'
                            id='email'
                            required={true}
                            type='text'
                            value={form.email}
                          >

                          </InputField>
                         </div>
                          
                          <button type="button" onClick={this.verify} className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Reset</button>
                          <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                              Don’t have an account yet? <Link to="/signup" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Sign up</Link>
                          </p>
                      </form>
                  </div>
              </div>
          </div>
        </section>
        )
    }
}

export default Forgot